// skills
import html from "../images/skills/html.svg";
import css from "../images/skills/css.svg";
import javascript from "../images/skills/javascript.svg";
import reactjs from "../images/skills/react.svg";
import node from "../images/skills/node.svg";
import git from "../images/skills/git.svg";
import nextjs from "../images/skills/nextjs.svg";
import sqlserver from "../images/skills/microsoftsqlserver.svg";
import dotnetcore from "../images/skills/dotnetcore.svg";
import typescript from "../images/skills/typescript.svg";
import vuejs from "../images/skills/vuejs.svg";
import tailwindcss from "../images/skills/tailwindcss.svg";
import bootstrap from "../images/skills/bootstrap.svg";
import nuxtjs from "../images/skills/nuxtjs.svg";
import wordpress from "../images/skills/wordpress.svg";
// ###########
// skills
// ###########

export const skills = [
  {
    id: 1,
    title: "HTML",
    icon: html,
  },
  {
    id: 2,
    title: "CSS",
    icon: css,
  },
  {
    id: 3,
    title: "Javascript",
    icon: javascript,
  },
  {
    id: 4,
    title: "TypeScript",
    icon: typescript,
  },
  {
    id: 5,
    title: "ReactJs",
    icon: reactjs,
  },
  {
    id: 6,
    title: "NextJs",
    icon: nextjs,
  },
  {
    id: 7,
    title: "VueJs",
    icon: vuejs,
  },
  {
    id: 8,
    title: "NuxtJs",
    icon: nuxtjs,
  },
  {
    id: 9,
    title: "Nodejs",
    icon: node,
  },
  {
    id: 10,
    title: "Git & GitHub",
    icon: git,
  },
  {
    id: 11,
    title: "SQL Server",
    icon: sqlserver,
  },
  {
    id: 12,
    title: ".NET Core",
    icon: dotnetcore,
  },
  {
    id: 13,
    title: "TailwindCSS",
    icon: tailwindcss,
  },
  {
    id: 14,
    title: "Bootstrap",
    icon: bootstrap,
  },
  {
    id: 15,
    title: "Wordpress",
    icon: wordpress,
  },
];
